module.exports = __webpack_public_path__ + "img/pic_empty.d38d6e7d.png";